import { React, useState } from "react";
import BannerBreadcrumb from "../Components/BannerBreadcrumb";

const BecomeAPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        company: "",
        studentCount: "",
        country: "",
        address: "",
        reference: "",
        type: "partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});

    const validate = () => {
        const errors = {};
        // Phone: must be 10 digits, numeric only
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        // Email: basic email regex
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        // For phone, allow only digits
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        // For name, allow only letters and spaces
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        // For email, allow any character (validation is handled separately)
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                company: "",
                studentCount: "",
                country: "",
                address: "",
                reference: "",
                type: "partner"
            });
        } catch (err) {
            console.error("Error submitting form:", err);
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };

    return (
        <>
            <BannerBreadcrumb head={"Become A Partner"} pagename={"Become A Partner"} />
            <div className="container">
                <div className="row">
                    <div className="col-md-6 loan-eligibility-partner">
                        <h5 className="about-head">Become our Partner</h5>
                        <p className="loan-elegibility-des">Just give us a few details and we will walk you through the product in a tailor fit mode just for you. We would be happy to answer any questions you have regarding the product.</p>
                        <img src="images/partner.jpg" className="img-fluid" alt="Become A Partner" />
                    </div>
                    <div className="col-md-6">
                        <form className="loan-check-form" onSubmit={handleSubmit}>
                            <h4>Fill in the Details Below</h4>
                            {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                            {error && <div className="alert alert-danger mt-2">{error}</div>}
                            <div className="row">
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Your Name <span>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control finance-input"
                                        placeholder="E.g. Priya Senger"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Official Email ID <span>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control finance-input"
                                        placeholder="E.g. priya@doe.com"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                    {fieldErrors.email && (
                                        <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                    )}
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Phone Number<span>*</span></label>
                                    <input
                                        type="tel"
                                        className="form-control finance-input"
                                        placeholder="E.g. 8888880000"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                        maxLength={10}
                                    />
                                    {fieldErrors.phone && (
                                        <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                    )}
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Company Name <span>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control finance-input"
                                        placeholder="E.g. IT Solution"
                                        name="company"
                                        value={formData.company}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">How many students do you send abroad every year <span>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control finance-input"
                                        placeholder="Student Count"
                                        name="studentCount"
                                        value={formData.studentCount}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Company Registered Country <span>*</span></label>
                                    <select
                                        className="form-select finance-input"
                                        name="country"
                                        value={formData.country}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="" disabled>Select Company Registered Country</option>
                                        <option value="India">India</option>
                                        <option value="USA">USA</option>
                                        <option value="Canada">Canada</option>
                                        <option value="UK">UK</option>
                                        <option value="Germany">Germany</option>
                                        <option value="Australia">Australia</option>
                                        <option value="Ireland">Ireland</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Company Registered Address <span>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control finance-input"
                                        placeholder="Company Registered Address"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">How did you hear about us? </label>
                                    <select
                                        className="form-select finance-input"
                                        name="reference"
                                        value={formData.reference}
                                        onChange={handleChange}
                                    >
                                        <option value="" disabled>Enter Your Reference Here</option>
                                        <option value="Google Search">Google Search</option>
                                        <option value="Referral">Referral</option>
                                        <option value="Event">Event</option>
                                        <option value="Linkedln">Linkedln</option>
                                        <option value="Email">Email</option>
                                        <option value="Advertisement">Advertisement</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                                <div className="col-12">
                                    <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                        {loading ? "Submitting..." : "Get In Touch"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BecomeAPartner;